import ko from "knockout";

import dateHelper from "../utils/dateHelper";
import logger from "../logger";

import { MaybeObservable } from "../interfaces/MaybeObservable";

declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface KnockoutPunchesFilters {
        timeFormat(valueObs: MaybeObservable<string>, includeSeconds: boolean): string;
    }
}

ko.filters.timeFormat = function (valueObs: MaybeObservable<string>, includeSeconds: boolean = false): string {
    const rawValue = ko.unwrap(valueObs);
    try {
        return dateHelper.toLocalTimeFormat(rawValue, false, includeSeconds);
    } catch (e) {
        logger.error("date filter error:", e);
        return rawValue; // Return the original value if transformation fails
    }
};
